export enum overrideReasonsActionTypes {
  OVERRIDE_REASONS_REQUESTED = 'OVERRIDE_REASONS_REQUESTED',
  OVERRIDE_REASONS_SUCCEEDED = 'OVERRIDE_REASONS_SUCCEEDED',
  OVERRIDE_REASONS_FAILED = 'OVERRIDE_REASONS_FAILED'
}
